<div [class]="getContainerClass()">
    <span class="label">{{currency}}</span>
</div>